import { render, staticRenderFns } from "./ReturnGoods3.vue?vue&type=template&id=05052363&"
import script from "./ReturnGoods3.vue?vue&type=script&lang=ts&"
export * from "./ReturnGoods3.vue?vue&type=script&lang=ts&"
import style0 from "./ReturnGoods3.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports